import * as React from 'react';
import { cn } from '@/lib/utils';

const WidgetWrapper = React.forwardRef(({ className, space, variant, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-widget-wrapper',
      // styles
      'mb-5 flex flex-wrap gap-5',
      space === 'sm' && 'mb-8 gap-3',
      variant === 'chart' && 'grid grid-cols-[repeat(auto-fit,minmax(250px,1fr))] justify-center justify-items-center [&>*]:w-full',
      variant === 'col' && 'flex flex-wrap [&>*]:min-w-[300px] [&>*]:grow [&>*]:basis-0',
      className
    )}
    {...props}
  />
));
WidgetWrapper.displayName = 'WidgetWrapper';

const WidgetWrapperCol = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-widget-wrapper-col',
      // styles
      'flex flex-wrap [&>*]:min-w-[300px] [&>*]:grow [&>*]:basis-0',
      className
    )}
    {...props}
  />
));
WidgetWrapperCol.displayName = 'WidgetWrapperCol';

const Widget = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-widget', 'max-w-full grow rounded-lg bg-white p-6 shadow-dropshadow', className)}
    {...props}
  />
));
Widget.displayName = 'Widget';

const WidgetHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-widget-header', 'mb-4', '[&_p]:mb-0', className)}
    {...props}
  />
));
WidgetHeader.displayName = 'WidgetHeader';

const WidgetHeaderContent = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-widget-header-content', 'flex items-center gap-3 [&_.c-widget-title]:grow', className)}
    {...props}
  />
));
WidgetHeaderContent.displayName = 'WidgetHeaderContent';

const WidgetTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn('c-widget-title', 'mb-0 text-base font-bold leading-tight text-primary-dark', className)}
    {...props}
  />
));
WidgetTitle.displayName = 'WidgetTitle';

const WidgetSubtitle = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-widget-subtitle', 'text-sm font-light text-neutral', className)}
    {...props}
  />
));
WidgetSubtitle.displayName = 'WidgetSubtitle';

const WidgetDescription = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('c-widget-description', 'leading-1.5 mb-0 text-xs font-light text-primary-dark', className)}
    {...props}
  />
));
WidgetDescription.displayName = 'WidgetDescription';

const WidgetText = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn('c-widget-text', 'text-sm font-light text-neutral', className)}
    {...props}
  />
));
WidgetText.displayName = 'WidgetText';

const WidgetBody = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-widget-body', className)}
    {...props}
  />
));
WidgetBody.displayName = 'WidgetBody';

const WidgetCount = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn('c-widget-count', 'shrink-0 text-base font-bold text-primary', '[&>span]:text-sm [&>span]:font-light [&>span]:text-neutral', className)}
    {...props}
  />
));
WidgetCount.displayName = 'WidgetCount';

export { WidgetWrapper, WidgetWrapperCol, Widget, WidgetHeader, WidgetHeaderContent, WidgetTitle, WidgetText, WidgetSubtitle, WidgetDescription, WidgetBody, WidgetCount };
